var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-wrapper"},[_c('div',{staticClass:"grid-container"},[_c('div',{staticClass:"grid"},_vm._l((_vm.slides),function(slide,i){return _c('div',{key:("ss-" + i),staticClass:"grid__item",class:{
          'is-odd': _vm.slides.length % 2,
        }},[_c('img',{directives:[{name:"src",rawName:"v-src",value:(slide),expression:"slide"}],attrs:{"alt":slide.alt}})])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }